export const statusInvoice = status => {
    switch ( String(status) ) {
        case 'UNPAID':
            return { status: `ยังไม่ชำระเงิน` , color: `text-danger`}
        case 'PAID':
            return { status: `ชำระแล้ว` , color: `text-success` } 
        default:
            return { status: `-` }
    }
};